import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { CustomizerSettingsService } from '../app/components/customizer-settings/customizer-settings.service';
import { ToggleService } from '../app/components/common/header/toggle.service';
import { TemaService } from './services/tema.services';
import { ConnectionStatusService } from './services/connection-status.service';
import { SessionService } from './services/session.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
    isToggled = false;
    themeClass: string;
    private subDarkMode: Subscription;

    screenHeight: number = innerHeight;
    screenWidth: number = innerWidth;

    constructor(
        public router: Router,
        private toggleService: ToggleService,
        public themeService: CustomizerSettingsService,
        public temaservice: TemaService,
        private titleService: Title,
        private connectionStatusService: ConnectionStatusService,
        // Se instancia al arrancar: registra los interceptores de axios y el heartbeat de sesión única
        private sessionService: SessionService
    ) {
        this.toggleService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });

        window.onresize = (e) => {
            console.log(window.innerHeight);
            console.log(window.innerWidth);

            this.screenHeight = window.innerHeight;
            this.screenWidth = window.innerWidth;
        }
    }

    ngOnInit(): void {
        this.subDarkMode = this.temaservice.valDarkTheme.subscribe({
            next: (data: any) => {
                this.setTheme(data ? 'dark-theme' : 'light-theme');
            }
        });

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            let title = 'Nectum Investment';
            
            // Get current route
            const currentRoute = this.router.url;
            
            // Set title based on route
            switch (true) {
                case currentRoute.includes('/broker-operations'):
                    title = 'Operaciones Broker | Nectum Investment';
                    break;
                case currentRoute.includes('/broker'):
                    title = 'Broker | Nectum Investment';
                    break;
                case currentRoute.includes('/gestor'):
                    title = 'Gestor | Nectum Investment';
                    break;
                case currentRoute.includes('/mercados'):
                    title = 'Mercados | Nectum Investment';
                    break;
                case currentRoute.includes('/models'):
                    title = currentRoute.includes('modo=analisis')
                        ? 'Screener | Nectum Investment'
                        : 'Modelos | Nectum Investment';
                    break;
                case currentRoute.includes('/confirmar'):
                    title = 'Control operativa | Nectum Investment';
                    break;
                case currentRoute.includes('/portfolio-labs'):
                case currentRoute.includes('/diversificador'):
                    title = 'Portfolio Labs | Nectum Investment';
                    break;
                case currentRoute.includes('/strategyfactory'):
                    title = 'Strategy Factory | Nectum Investment';
                    break;
                case currentRoute.includes('/grafica-modelo'):
                    title = 'Ver Gráfica | Nectum Investment';
                    break;
            }
            
            this.titleService.setTitle(title);
        });
    }
    
      private setTheme(tema: string) {
        this.themeClass = tema;
        document.body.classList.remove('dark-theme', 'light-theme');
        document.body.classList.add(tema);
      }

      ngOnDestroy(): void {
        this.subDarkMode.unsubscribe();
    }
}
